import queryString from 'query-string';
import FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';
import { getDefaultOptions } from '@atlassian/jira-fetch/src/utils/fetch-default-options.tsx';
import { SEARCH_ORDER, SEARCH_MAX_RESULTS } from '../../../model/constants.tsx';
import { ProjectLocation, UserAccountLocation, type LocationType } from '../../../model/index.tsx';

export const getRawUrl = (baseUrl: string) => `${baseUrl}/rest/agile/1.0/board`;

const getLocationQueryParamName = (locationType: LocationType) => {
	switch (locationType) {
		case ProjectLocation:
			return 'projectLocation';
		case UserAccountLocation:
			return 'accountIdLocation';
		default:
			return 'usernameLocation';
	}
};

export const getUrl = (
	baseUrl: string,
	search?: string,
	// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
	locationType: LocationType,
	locationKey: string,
	negateLocationFiltering: boolean,
	startAt: number,
) => {
	const locationParamName = getLocationQueryParamName(locationType);

	const params = {
		...(search ? { name: search } : {}),
		negateLocationFiltering,
		orderBy: SEARCH_ORDER,
		maxResults: SEARCH_MAX_RESULTS,
		startAt,
		[locationParamName]: locationKey,
		overrideFilterPermissions: true,
	};

	const rawUrl = getRawUrl(baseUrl);
	return `${rawUrl}?${queryString.stringify(params)}`;
};

export type ResponseBoard = {
	id: string;
	name: string;
	location?: {
		userId?: string;
		name: string;
		avatarURI: string;
		projectKey: string;
		userAccountId?: string;
	};
	type: string;
};

export type Response = {
	values: ResponseBoard[];
	total: number;
};

const getSearchBoards = async (
	baseUrl: string,
	search?: string,
	// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
	locationType: LocationType,
	locationKey: string,
	negateLocationFiltering = false,
	startAt = 0,
): Promise<Response> => {
	const url = getUrl(baseUrl, search, locationType, locationKey, negateLocationFiltering, startAt);
	const response = await fetch(url, getDefaultOptions(url));

	if (!response.ok) {
		const text = await response.text();
		throw new FetchError(response.status, text);
	}

	return response.json();
};

export default getSearchBoards;
